/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SupressProgramBudgetTypeTipMessageInput = {
    key?: string | null | undefined;
    personId?: string | null | undefined;
    value?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type SupressProgramBudgetTypeTipMessageMutationVariables = {
    input: SupressProgramBudgetTypeTipMessageInput;
};
export type SupressProgramBudgetTypeTipMessageMutationResponse = {
    readonly supressProgramBudgetTypeTipMessage: {
        readonly clientMutationId: string | null;
        readonly person: {
            readonly id: string;
            readonly supressProgramBudgetTypeTipMessage: ReadonlyArray<string | null> | null;
        } | null;
    } | null;
};
export type SupressProgramBudgetTypeTipMessageMutation = {
    readonly response: SupressProgramBudgetTypeTipMessageMutationResponse;
    readonly variables: SupressProgramBudgetTypeTipMessageMutationVariables;
};



/*
mutation SupressProgramBudgetTypeTipMessageMutation(
  $input: SupressProgramBudgetTypeTipMessageInput!
) {
  supressProgramBudgetTypeTipMessage(input: $input) {
    clientMutationId
    person {
      id
      supressProgramBudgetTypeTipMessage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SupressProgramBudgetTypeTipMessageInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SupressProgramBudgetTypeTipMessagePayload",
    "kind": "LinkedField",
    "name": "supressProgramBudgetTypeTipMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "supressProgramBudgetTypeTipMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SupressProgramBudgetTypeTipMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SupressProgramBudgetTypeTipMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SupressProgramBudgetTypeTipMessageMutation",
    "operationKind": "mutation",
    "text": "mutation SupressProgramBudgetTypeTipMessageMutation(\n  $input: SupressProgramBudgetTypeTipMessageInput!\n) {\n  supressProgramBudgetTypeTipMessage(input: $input) {\n    clientMutationId\n    person {\n      id\n      supressProgramBudgetTypeTipMessage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '41e6d863af861b2e1d5b1b22b1826a7f';
export default node;
